module.exports = __webpack_public_path__ + "static/img/chef-bg.9fe430d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chef-bg.png
// module id = lCK8
// module chunks = 0